"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalSettingsColumnCells = void 0;
const autocomplete_cell_1 = require("./column-cells/autocomplete-cell");
const checkbox_cell_1 = require("./column-cells/checkbox-cell");
const date_cell_1 = require("./column-cells/date-cell");
const number_cell_1 = require("./column-cells/number-cell");
const select_cell_1 = require("./column-cells/select-cell");
const text_cell_1 = require("./column-cells/text-cell");
exports.InternalSettingsColumnCells = {
    AutocompleteCell: autocomplete_cell_1.AutocompleteCell,
    SelectCell: select_cell_1.SelectCell,
    TextCell: text_cell_1.TextCell,
    TextMultipleCell: text_cell_1.TextMultipleCell,
    NumberCell: number_cell_1.NumberCell,
    NumberMultipleCell: number_cell_1.NumberMultipleCell,
    LocalDateCell: date_cell_1.LocalDateCell,
    LocalDateTimeCell: date_cell_1.LocalDateTimeCell,
    InstantCell: date_cell_1.InstantCell,
    CheckboxCell: checkbox_cell_1.CheckboxCell,
};
//# sourceMappingURL=internal-settings-column-cells.js.map